import { OVERLAY_TYPE } from '@ulta/core/providers/OverlayProvider/OverlayProvider';
import { handleEmptyObjects } from '@ulta/core/utils/handleEmptyObjects/handleEmptyObjects';

/**
 * function to return conditional props for Subscription component in pdp page
 *
 * @method getPdpProps
 * @param {object} data
 * @returns {undefined}
 */
export const getPdpProps = ( data ) => {
  const {
    isSubscriptionDisabled = false,
    isMobile = false
  } = handleEmptyObjects( data );

  const pdpProps = {
    tagIconColor: 'default',
    tagTextColor: 'default',
    buttonNavigationType: 'flyout'
  };

  if( isSubscriptionDisabled ){
    pdpProps.tagIconColor = 'grayscale';
    pdpProps.tagTextColor = 'content-xsubtle';
  }

  if( isMobile ){
    pdpProps.buttonNavigationType = OVERLAY_TYPE.BottomSheet;
  }

  return pdpProps;
};


/**
 * function to return conditional props for Subscription Learn more component
 *
 * @method getSubsTermsProps
 * @param {object} data
 * @returns {undefined}
 */
export const getSubsTermsProps = ( data ) => {
  const {
    isMobile = false
  } = handleEmptyObjects( data );

  const subsTermsProps = {
    linkTarget: '_blank'
  };

  if( isMobile ){
    subsTermsProps.linkTarget = '_self';
  }

  return subsTermsProps;
};

/**
 * function to return conditional props for Cart Subscription Indicator component
 *
 * @method getSubsCartIndicatorProps
 * @param {object} data
 * @returns {undefined}
 */
export const getSubsCartIndicatorProps = ( data ) => {
  const {
    isSubscribed = false,
    addSubscriptionTitle,
    updateSubscriptionTitle,
    subsEditLabelAction,
    subsAddLabelAction
  } = handleEmptyObjects( data );

  const subsCartIndicatorProps = {
    tagBackgroundColor: 'background-xsubtle',
    subscriptionOverlayTitle: addSubscriptionTitle?.text,
    actionLink: subsAddLabelAction,
    showIndicatorWithoutLink: false,
    tagTextColor: null
  };
  if( !subsAddLabelAction && !subsEditLabelAction ){
    subsCartIndicatorProps.tagBackgroundColor = 'background-default';
    subsCartIndicatorProps.showIndicatorWithoutLink = true;
    subsCartIndicatorProps.tagTextColor = 'content-xsubtle';
  }
  else if( isSubscribed ){
    subsCartIndicatorProps.tagBackgroundColor = 'background-brand-03';
    subsCartIndicatorProps.subscriptionOverlayTitle = updateSubscriptionTitle?.text;
    subsCartIndicatorProps.actionLink = subsEditLabelAction;
  }
  return subsCartIndicatorProps;
};

/**
 * function to return conditional props for Subscription update component in pdp page
 *
 * @method getSubsUpdateProps
 * @param {object} data
 * @returns {undefined}
 */
export const getSubsUpdateProps = ( data ) => {
  const {
    isProductSubscribed = false,
    addSubscriptionTitle,
    updateSubscriptionTitle,
    addSubscriptionSubTitle
  } = handleEmptyObjects( data );

  const subProps = {
    title: addSubscriptionTitle,
    subTitle: addSubscriptionSubTitle
  };

  if( isProductSubscribed ){
    subProps.title = updateSubscriptionTitle;
    subProps.subTitle = null;
  }

  return subProps;
};

/**
* Checks whether subscription is eligible for the given fulfillment type
*
* @method
* @param {object} fulfillmentTypes
* @param {string} selectFulfillment
* @returns {string}
*/
export const isFulfillmentSubscriptionEligible = ( fulfillmentTypes, selectFulfillment ) => {
  if( fulfillmentTypes && selectFulfillment && Array.isArray( fulfillmentTypes ) ){
    return fulfillmentTypes.some( i => i.type === selectFulfillment && i.isSubscriptionEligible );
  }
  else {
    return false;
  }
};
